import { IoIosNotificationsOutline } from "react-icons/io";
import STHeaderNotification from "../../../assets/styles/organisms/headerNotification.module.scss";
import { Button, Popover } from "@material-ui/core";
import { useGetNotification, useMarkAsReadNotifications } from "./hooks";
import { useConnectNotifications } from "./websocket";
import { NotificationsProvider, useNotification } from "./NotificationProvider";
import NotificationList from "./NotificationList";

const Content = () => {
  useConnectNotifications();
  useGetNotification();
  const {
    state: { hasNotificationUnread, actionAnchorElement },
    toggleNotificationsPopup,
  } = useNotification();
  const { markAsReadNotifications } = useMarkAsReadNotifications();

  const handleClickActionButton = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    toggleNotificationsPopup(event.currentTarget);

    if (hasNotificationUnread) {
      await markAsReadNotifications();
    }
  };
  const handleCloseActionButton = () => {
    toggleNotificationsPopup(null);
  };
  const openActionPopover = Boolean(actionAnchorElement);
  const actionId = openActionPopover ? "action-popover" : undefined;

  return (
    <div>
      <div className={STHeaderNotification.iconWrapper}>
        <Button aria-describedby={actionId} onClick={handleClickActionButton}>
          <IoIosNotificationsOutline />
        </Button>
        {!!hasNotificationUnread && (
          <div className={STHeaderNotification.totalNotifications}></div>
        )}
      </div>
      <Popover
        id={actionId}
        open={openActionPopover}
        anchorEl={actionAnchorElement}
        onClose={handleCloseActionButton}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div
          className={STHeaderNotification.notificationWrapper}
          onClick={handleCloseActionButton}
        >
          <div className={STHeaderNotification.title}>通知</div>
          <NotificationList />
        </div>
      </Popover>
    </div>
  );
};

const HeaderNotification = () => {
  return (
    <NotificationsProvider>
      <Content />
    </NotificationsProvider>
  );
};
export default HeaderNotification;
